var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagMozambique(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16064)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.6479 22.261L4.68652 27.3133C7.58177 30.2089 11.5813 32.0001 15.9997 32.0001C22.6141 32.0001 28.29 27.9858 30.7267 22.261H8.6479Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7515 9.79706C28.3285 4.04138 22.6365 0 15.9997 0C11.5813 0 7.58177 1.79119 4.68652 4.68681L8.6934 9.79706H30.7515Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.47852 11.7681V20.1738H31.4491C31.808 18.8431 32.0003 17.4441 32.0003 15.9999C32.0003 14.5348 31.8029 13.1161 31.434 11.7681H3.47852Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.68622 4.68628C-1.56215 10.9347 -1.56215 21.0653 4.68622 27.3138C7.26828 24.7317 9.75159 22.2484 16 16L4.68622 4.68628Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.4756 11.8262L7.51154 15.0147H10.8644L8.15204 16.9854L9.18791 20.174L6.4756 18.2034L3.76316 20.174L4.79929 16.9854L2.08691 15.0147H5.43954L6.4756 11.8262Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.44421 16H9.50821V18.7826H3.44421V16Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6562 12.81L9.67242 11.8262L6.47567 15.0229L3.27892 11.8262L2.2951 12.81L5.49467 16.0039L2.2951 19.2035L3.27892 20.174L6.47567 16.983L9.67242 20.174L10.6562 19.2035L7.45667 16.0039L10.6562 12.81Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16064"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagMozambique);
export default __webpack_public_path__ + "static/media/flag_mozambique.1d9f657d373b1ed58aef0f7dec898aa1.svg";
export { ForwardRef as ReactComponent };